import { render } from "./PredictionDialog.vue?vue&type=template&id=22dcefaa&scoped=true"
import script from "./PredictionDialog.vue?vue&type=script&lang=js"
export * from "./PredictionDialog.vue?vue&type=script&lang=js"

import "./PredictionDialog.vue?vue&type=style&index=0&id=22dcefaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22dcefaa"]])

export default __exports__